import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type PageTitleKey = 'home' | 'courses' | 'courseDetail' | 'web3' | 'dashboard' | 'profile' | 'login' | 'register' | 'default';

export const usePageTitle = (titleKey: PageTitleKey) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // 获取翻译的页面标题
    const title = t(`pageTitle.${titleKey}`);
    
    // 更新浏览器标签页标题
    document.title = title;
    
    // 清理函数：组件卸载时恢复默认标题
    return () => {
      document.title = t('pageTitle.default');
    };
  }, [t, titleKey, i18n.language]); // 依赖数组包含语言变化

  // 返回当前页面标题（可选，用于组件内部显示）
  return t(`pageTitle.${titleKey}`);
}; 